import {actionType} from '../types/type';
import { updateObject } from '../../helpers/utility.helper';
import IPreferences from '../../models/IPreferences';
import { initialState } from '../state/preferences.state';

const changeLanguage = (oldState:IPreferences, action: any) => {
	return updateObject(oldState, {
        language:action.payload,
        isLanguageChanged: true
    });
};

const updateLanguage = (oldState:IPreferences, action: any) => {
	return updateObject(oldState, {
        language:action.payload.language
    });
};

const resetIsLanguageChanged = (oldState:IPreferences, action: any) => {
	return updateObject(oldState, {
        isLanguageChanged: false
    });
};

const preferencesReducer = (oldState:IPreferences = initialState, action:any) => {
    switch (action.type) {
        case actionType.CHANGE_LANGUAGE: return changeLanguage(oldState, action);
        case actionType.UPDATE_LANGUAGE: return updateLanguage(oldState, action);
        case actionType.RESET_IS_LANGUAGE_CHANGED: return resetIsLanguageChanged(oldState, action);
        default: return oldState;    
    }
};
export default preferencesReducer;